// The run stream's frames as they arrive (text/event-stream): `event:`, `id:` and `data:` lines
// up to a blank line, and `:` comments (the server's `: ping` heartbeat). Chunks split anywhere,
// even inside a line or between a CR and its LF; the parser keeps the remainder. Lifted from the
// H0 CLI, which reads the stream through this package since H1.12.
export class SseParser {
    buffer = "";
    id = null;
    event = null;
    data = [];
    sawField = false;
    /** Everything this chunk completes, in order. */
    push(chunk) {
        this.buffer += chunk;
        const items = [];
        while (true) {
            const newline = this.buffer.search(/\r\n|\r|\n/);
            if (newline === -1)
                break;
            // A CR at the very end may be the first half of a CRLF the next chunk completes.
            if (this.buffer[newline] === "\r" && newline === this.buffer.length - 1)
                break;
            const width = this.buffer.startsWith("\r\n", newline) ? 2 : 1;
            const line = this.buffer.slice(0, newline);
            this.buffer = this.buffer.slice(newline + width);
            const item = this.line(line);
            if (item)
                items.push(item);
        }
        return items;
    }
    line(line) {
        if (line === "") {
            if (!this.sawField)
                return null;
            const frame = { id: this.id, event: this.event, data: this.data.join("\n") };
            this.id = null;
            this.event = null;
            this.data = [];
            this.sawField = false;
            return { kind: "frame", frame };
        }
        if (line.startsWith(":"))
            return { kind: "comment", text: line.slice(1).trim() };
        const colon = line.indexOf(":");
        const field = colon === -1 ? line : line.slice(0, colon);
        let value = colon === -1 ? "" : line.slice(colon + 1);
        if (value.startsWith(" "))
            value = value.slice(1);
        this.sawField = true;
        if (field === "id")
            this.id = value;
        else if (field === "event")
            this.event = value;
        else if (field === "data")
            this.data.push(value);
        return null;
    }
}
//# sourceMappingURL=sse.js.map